<template>
  <div class="page-container">
    <ConfirmationDialogBox
      :title="'Remove AI Pool member? This action can not be undone.'"
      :isVisible="isDialogVisible"
      @confirmed="handleConfirmed"
      @cancelled="handleCancelled">
    </ConfirmationDialogBox>
    
    <ModalBox 
      :visible="showModal" 
      :infoTitle="infoTitle"  
      :infoMessage="infoMessage" 
      @close="showModal = false">
    </ModalBox>

    <div class="tabs">
      <button 
        v-for="tab in tabs" 
        :key="tab.name" 
        :class="{ active: activeTab === tab.name, inactive: activeTab !== tab.name }" 
        @click="activeTab = tab.name">
        {{ tab.label }}
      </button>
    </div>
    
    <div class="tab-content">  
      <div v-if="activeTab === 'tab2'">    
       <ApiDoc></ApiDoc>
      </div>
      <div v-if="activeTab === 'tab1'">    
        <div v-if="activeView === 'PoolTableView'">
          <div class="flex-container">
            <button class="custom-button button-option active" @click="activeView = 'PoolNewMemberView'">
              Add New Member
            </button>
          </div>
   
          <div class="table-container">
            <table class="full-width-table">
              <thead>
                <tr>
                  <th v-for="header in tableHeaders" :key="header">{{ header }}</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(row, index) in poolDataList" :key="row.plant_id">
                  <tr>
                    <td>{{ row.alias }}</td>
                    <td>{{ row.plant_id }}</td>
                    <td>
                      <template v-if="row.ai_control_status == 0">
                        <font-awesome-icon :icon="['fas', 'link-slash']" class="icon-disabled" />
                      <p>Disabled</p>
                      </template>
                      <template v-else>
                        <font-awesome-icon :icon="['fas', 'circle-check']" class="icon-enabled" />
                      <p>Enabled</p>
                      </template>
                    </td>
                    <td>
                      <template v-if="row.realtime_operation_status == 0">
                        <div class="status-circle status-disabled"></div>
                        <p>Inactive</p>
                      </template>
                      <template v-else>
                        <div class="status-circle status-enabled blink"></div>
                        <p>Active</p>
                      </template>
                    </td>
                    


                    <td>
                      <button @click="toggleDetails(index)" class="custom-button arrow-button">
                        {{ showDetails[index] ? '▲' : '▼' }}
                      </button>
                      <button 
                        class="button-sensitive" 
                        @click="showConfirmationDialog(index)">
                        x
                      </button>
                    </td>
                  </tr>
                  <tr v-if="showDetails[index]">
                    <td colspan="5">
                      <div class="details-row">
                        <h5><strong>Set / Modify Details</strong></h5>
                        <br>
                        <form>
                        <!-- <p>Plant ID: {{ row.plant_id }}</p> -->
                        <br>
                        <!-- <p>: {{ row.alias }}</p> -->
                        <label for="aliasValue">Alias</label>
                        <br>
                        <input type="text" v-model="form.alias" required />
                        <br>
                        <br>
                        <br>
                        <label for="aiControlStatus">AI Control Status</label>
                        <br>
          <select v-model="form.ai_control_status" required>
            <option value=0>Disabled</option>
            <option value=1>Enabled</option>
          </select>
          <br>

          <button type="button" @click="saveChanges(index)" class="custom-button button-option active">Save Changes</button>

        </form>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="activeView === 'PoolNewMemberView'" class="flex-container">
          <div class="flex-container">
            <button class="custom-button button-option active" @click="activeView = 'PoolTableView'">
              Back To Pool View
            </button>
          </div>
   
          <h5>Add new plant to the pool</h5>
          <div class="member-addition">
            <div class="options">
              <button 
                class="custom-button button-option" 
                :class="{ active: selectedMethod === 'byId' }" 
                @click="selectMethod('byId')">
                Add by ID
              </button>
              <button 
                class="custom-button button-option" 
                :class="{ active: selectedMethod === 'byAutocomplete' }" 
                @click="selectMethod('byAutocomplete')">
                Search by name
              </button>
            </div>

            <div v-if="selectedMethod === 'byId'">
              <h6>Enter Renox Plant ID</h6>
              <input 
                class="custom-input" 
                type="text" 
                v-model="memberId" 
                placeholder="Enter ID" />
              <button 
                class="custom-button button-option"
                :class="{ active: (memberId != 0 && memberId != '' && Number(memberId)) }"
                @click="getPlantById">
                Continue
              </button>
            </div>

            <div v-if="selectedMethod === 'byAutocomplete'">
              <h6>Search for Renox account and plant names</h6>
              <input 
                class="custom-input" 
                type="text" 
                v-model="searchTerm" 
                placeholder="Type to search..." 
                @input="getPlantByAutocomplete(searchTerm)" />
            </div>

            <h6>Found Plants ({{ listPlantByIdDataResponse.length }})</h6>
            <div class="result-box" v-if="listPlantByIdDataResponse.length > 0">
              <div v-for="(item, index) in listPlantByIdDataResponse" :key="index">
                <ul>
                  <a href="#" @click.prevent="selectedResultIndex = index">
                    <li>
                      <div 
                        class="result-item styled-border" 
                        :class="{ selectedResult: (selectedResultIndex === index) }">
                        <p>Plant ID: {{ item.plant_id }}</p>
                        <p>Plant Name: {{ item.plant_name }}</p>
                        <p>Account Name: {{ item.account_name }}</p>
                        <p>Date Created: {{ item.date_created }}</p>
                      </div>
                    </li>
                  </a>
                </ul>
              </div> 
              <div class="flex-container">
                <button 
                  class="custom-button button-option"
                  :class="{ active: selectedResultIndex != -1 }"      
                  @click="addPlantToPool">
                  Add To Pool
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiRequest } from '@/services/apiService';
import ModalBox from '@/components/cards/ModalBox.vue';
import ConfirmationDialogBox from '@/components/cards/ConfirmationDialogBox.vue';
import ApiDoc from '../cards/ApiDoc.vue';

export default {
name: 'ConfigurationPage',
components: {
  ModalBox,
  ConfirmationDialogBox,
  ApiDoc,
},
data() {
  return {
    form: {
      ai_control_status: 0,
    },
    isDialogVisible: false,
    subDataUrl: '/api/v1.1/data',
    tableHeaders: ['Alias', 'Renox Plant ID', 'AI Control', 'Realtime Operation Status'],
    showDetails: [],
    poolDataList: [],
    activeTab: 'tab1',
    tabs: [
      { name: 'tab1', label: 'AI Pool' },
      // { name: 'tab2', label: 'API Documentation' },
    ],
    selectedMethod: 'byId',
    memberId: '',
    searchTerm: '',
    activeView: 'PoolTableView',
    listPlantByIdDataResponse: [],
    selectedResultIndex: -1,
    selectedTableRowIndex: -1,
    showModal: false,
    infoTitle: '',
    infoMessage: '',
  };
},
methods: {
  async getAllPoolData() {
    try {
      const url = `${this.subDataUrl}/ai_pool_users/get`;
      const response = await apiRequest('post', url, {});
      
      if (response.errorCode === 0 && response.data != null) {
        this.poolDataList = response.data;
        this.checkRealtimeRunningStatus();
        // Initialize showDetails array with false values for each row
        this.showDetails = new Array(this.poolDataList.length).fill(false);
      }
    } catch (error) {
      console.error('Error fetching ai pool data list:', error);
      this.showModal = true;
      this.infoTitle = "Error";
      this.infoMessage = "Failed to fetch pool data. Please try again later.";
    }
  },
  async checkRealtimeRunningStatus() {
    try {
      for (let index = 0; index < this.poolDataList.length; index++) {
        const value = this.poolDataList[index]; // Access the current object
        const url = `${this.subDataUrl}/proxy/ai_control/plants/${value.plant_id}/status`;

        // Await the API request
        const response = await apiRequest('post', url, {});

        // Check if the response status is valid and handle accordingly
        if (response && response.status) {
          if (response.status === 'success') {
            // Update the corresponding element's realtime_operation_status
            this.poolDataList[index].realtime_operation_status = 1;
          } else {
            this.poolDataList[index].realtime_operation_status = 0;
          }
        }
      }
    } catch (error) {
      // console.error('Error fetching realtime operation indicator:', error);
      this.showModal = true;
      this.infoTitle = "Error";
      this.infoMessage = "Failed to fetch realtime operation indicator. Please try again later.";
    }
},


  selectMethod(method) {
    this.selectedResultIndex = -1;
    this.listPlantByIdDataResponse = [];
    this.selectedMethod = method;
    this.memberId = '';
    this.searchTerm = '';
  },

  async getPlantById() {
    this.selectedResultIndex = -1;
    if (Number(this.memberId) > 0) {
      try {
        const bodyData = {
          plant_id: Number(this.memberId),
        };
        this.listPlantByIdDataResponse = [];
        const url = `${this.subDataUrl}/bridge/rx_data/plant/plant_info/get`;
        const response = await apiRequest('post', url, bodyData);
        
        if (response.errorCode === 0 && response.data) {
          this.listPlantByIdDataResponse = response.data;
        }
      } catch (error) {
        this.showModal = true;
        this.infoTitle = "Error";
        this.infoMessage = "Failed to fetch plant data. Please try again later.";
      }
    }
  },

  async addPlantToPool() {
    if (this.selectedResultIndex >= 0) {
      const selectedPlant = this.listPlantByIdDataResponse[this.selectedResultIndex];
      try {
        const bodyData = {
          plant_id: selectedPlant.plant_id,
          alias: selectedPlant.account_name + ' - ' + selectedPlant.plant_name,
        };
        const url = `${this.subDataUrl}/ai_pool_users/set`;
        const response = await apiRequest('post', url, bodyData);

        if (response.errorCode === 0) {
          this.infoTitle = "Success";
          this.infoMessage = "New AI pool member has been added successfully";
          this.showModal = true;
          this.selectedResultIndex = -1;
          this.listPlantByIdDataResponse = [];
          this.memberId = '';
          await this.getAllPoolData();
        } else {
          this.infoTitle = "Error";
          this.infoMessage = response.infoText || 'Unexpected error occurred';
          this.showModal = true;
        }
      } catch (error) {
        this.infoTitle = "Error";
        this.infoMessage = 'Unexpected backend response. Please try again later';
        this.showModal = true;
      }
    }
  },

  async getPlantByAutocomplete(inputValue) {
    this.selectedResultIndex = -1;
    if (inputValue.trim() === '' || inputValue.length < 3) {
      this.listPlantByIdDataResponse = [];
      return;
    }
    try {
      const bodyData = {
        input_text: inputValue,
      };
      const url = `${this.subDataUrl}/bridge/rx_data/autocomplete/plant_info/get`;
      const response = await apiRequest('post', url, bodyData);
      
      if (response.errorCode === 0 && response.data) {
        this.listPlantByIdDataResponse = response.data;
      }
    } catch (error) {
      this.showModal = true;
      this.infoTitle = "Error";
      this.infoMessage = "Failed to fetch plant data. Please try again later.";
    }
  },

  async removeFromPool(index) {
    try {
      const bodyData = {
        plant_id: this.poolDataList[index].plant_id,
      };
 
      const url = `${this.subDataUrl}/ai_pool_users/delete`;
      const response = await apiRequest('post', url, bodyData);
      
      if (response.errorCode === 0) {
        this.infoTitle = "Success";
        this.infoMessage = "AI pool member has been removed successfully";
        this.showModal = true;
        this.selectedTableRowIndex = -1;
        await this.getAllPoolData();
      } else {
        this.infoTitle = "Error";
        this.infoMessage = response.infoText || 'Unexpected error occurred';
        this.showModal = true;
      }
    } catch (error) {
      this.infoTitle = "Error";
      this.infoMessage = 'Unexpected backend response. Please try again later';
      this.showModal = true;
    }
  },

  showConfirmationDialog(index) {
    this.isDialogVisible = true;
    this.selectedTableRowIndex = index;
  },

  handleConfirmed() {
    this.isDialogVisible = false;
    this.removeFromPool(this.selectedTableRowIndex);
  },

  handleCancelled() {
    this.isDialogVisible = false;
    this.selectedTableRowIndex = -1;
  },
  toggleDetails(index) {
    // Directly toggle the value of showDetails for the given index
    this.showDetails = [];
    this.showDetails[index] = !this.showDetails[index];
    this.form.alias = this.poolDataList[index].alias;
    this.form.ai_control_status = this.poolDataList[index].ai_control_status;
},
async saveChanges(index) {
    console.log('saveChanges f1', index);
    if (this.showDetails.length > 0) {   
      console.log('saveChanges f2');   
      console.log('this.showDetails', this.showDetails[index]);   
      try {
        const bodyData = {
          plant_id: this.poolDataList[index].plant_id,
          alias: this.form.alias,
          ai_control_status: Number(this.form.ai_control_status),
        };
        const url = `${this.subDataUrl}/ai_pool_users/update`;
        const response = await apiRequest('post', url, bodyData);
        console.log('API Response before f3:', response);
        console.log('saveChanges f3');   
        if (response.errorCode === 0) {
          this.infoTitle = "Success";
          this.infoMessage = "AI pool member details updated successfully";
          this.showModal = true;
          this.showDetails = [];
          await this.getAllPoolData();
        } else {
          this.infoTitle = "Error";
          this.infoMessage = response.infoText || 'Unexpected error occurred';
          this.showModal = true;
        }
      } catch (error) {
        console.log('saveChanges f4e'); 
        this.infoTitle = "Error";
        this.infoMessage = 'Unexpected backend response. Please try again later';
        this.showModal = true;
      }
    }
  },


},

created() {
  this.getAllPoolData();
},
};
</script>
  <style scoped>
  .page-container {
    margin: 0;
    padding: 0;
  }
  
  .tabs {
    padding-top: 20px;
    display: flex;
    margin-bottom: 20px;
  }
  
  .tabs button {
    padding: 10px;
    margin: 10px 0px 10px 30px;
    cursor: pointer;
    border: none;
    margin-right: 5px;
    border-radius: 5px; /* Rounded borders */
    transition: color 0.3s;
    position: relative; /* For positioning the border */
  }

  
  /* .tabs button.active {
    color: white; /* Active tab text color
  } */
  
  .tabs button.active::after {
    content: ''; /* Empty content for the border */
    position: absolute;
    left: 0;
    right: 0;
    bottom: -5px; /* Positioning the line */
    height: 3px; /* Thickness of the line */
    background-color: #8cd584; /* Green line color */
  }
  
  .tabs button.inactive {
    color: rgb(196, 194, 194); /* Active tab text color */
    opacity: 0.6; /* Gray out inactive tabs */
  }
  
  .tab-content {
    margin: 20px;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px; /* Match border radius with tabs */
    background: #fff;
  }
  .options {
  display: flex;
  gap: 10px; /* Space between the option buttons */
  }

.member-addition {
  margin-top: 20px;
}

input {
  padding: 8px;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 200px; /* Fixed width for input */
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  cursor: pointer;
  padding: 5px;
  border: 1px solid #ccc;
  margin-top: 5px;
}

li:hover {
  background-color: #f0f0f0; /* Highlight on hover */
}

.custom-button {
  margin: 20px;
  color:rgb(196, 194, 194);
  background-color: grey;
}

.button-option.active {
  background-color: #8cd584; /* Active button background color */
  color: white; /* Active button text color */
}

.selectedResult {
  background-color: #3aa42c; /* Highlight selected result */
}

a{
  text-decoration: none; /* Remove underline */
}
.result-item{
    border-radius: 5px; /* Rounded borders */
    text-decoration: none;
    color: black;
  }

  .table-container {
    width: 100%; /* Ensures the container takes full width */
    overflow-x: auto; /* Allows horizontal scrolling if needed */
  }

  .full-width-table {
    width: 100%; /* Table takes full width of the container */
    border-collapse: collapse; /* Collapses borders for a cleaner look */
  }
    
  th, td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
    font-size: 0.8rem;
  }
  
  th {
    background-color: #b9def1;
  }

  .icon-disabled {
    color: red;
  }

  .icon-enabled {
    color: green;
  }

  .details-row {
    padding: 10px;
    border: 1px solid #349237;
    border-radius: 5px;
    margin-top: 10px;
  }

  .arrow-button {
    background-color: #8cd584;
    color: white;
  }

input,
select {
  width: 60%;
  padding: 10px;
  margin: 10px 0;
  border-radius: 8px;
  border-width: 0.1px;
} 

  .status-circle {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: inline-block;
  }

  .status-disabled {
    background-color: red;
  }

  .status-enabled {
    background-color: green;
  }

  @keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
  }

  .blink {
    animation: blink 0.8s infinite;
  }


  @media (max-width: 750px) {

    th, td {
    font-size: 0.3rem;
    }
    button {
      font-size: 10px;
    }
  }


</style>
  